import actionTypes from './actionTypes'

const {
  REQUEST_ROOMS,
  SERVER_ERROR_OCURED
} = actionTypes

function requestSeminarRooms() {
  return {
    type: REQUEST_ROOMS
  }
}

function hasErrored(bool) {
  return {
    type: SERVER_ERROR_OCURED,
    hasErrored: bool
  }
}



// WEBPACK FOOTER //
// src/routes/Room/actions/index.js